import { css, SerializedStyles } from '@emotion/react';
import { ReactElement, ReactNode } from 'react';

import { styled } from '../../styled';
import type { Theme } from '../../theme/interface/detailed';

type Interface = { className: string; children: ReactNode };

const style = ({
	theme: {
		allSettings: {
			containers: { chatContainer },
		},
	},
}: {
	theme: Theme;
}): SerializedStyles => css`
	display: flex;
	background: ${chatContainer.background};
	flex-direction: column;
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
`;

const Component = ({ className, children }: Interface): ReactElement => {
	return <div className={className}>{children}</div>;
};

export const ChatMobileContainer = styled(Component)(style);
